var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPresentation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6875 34.4375V38.5",
    stroke: "#4C5B66",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.75 11.6875V32.8125C40.7487 33.2431 40.5771 33.6557 40.2726 33.9601C39.9682 34.2646 39.5556 34.4362 39.125 34.4375H8.25C7.81942 34.4362 7.40684 34.2646 7.10237 33.9601C6.7979 33.6557 6.62629 33.2431 6.625 32.8125V9.25H40.75V11.6875Z",
    fill: "url(#paint0_linear_103_2965)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3125 38.5H22.0625V43.375H25.3125V38.5Z",
    fill: "#5EA7FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.375 6V9.25H40.75H6.625H5V6H42.375Z",
    fill: "#5EA7FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 9.25H5V6H42.375V9.25H40.75H6.625Z",
    fill: "#8BC5FC",
    stroke: "#4C5B66",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 11.6875V32.8125C6.62629 33.2431 6.7979 33.6557 7.10237 33.9601C7.40684 34.2646 7.81942 34.4362 8.25 34.4375H39.125C39.5556 34.4362 39.9682 34.2646 40.2726 33.9601C40.5771 33.6557 40.7487 33.2431 40.75 32.8125V11.6875",
    stroke: "#4C5B66",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3125 38.5H22.0625V43.375H25.3125V38.5Z",
    stroke: "#4C5B66",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 13.3125H11.5V16.5625H14.75V13.3125Z",
    fill: "#DDB346",
    stroke: "#815719",
    strokeOpacity: 0.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 19.8125H11.5V23.0625H14.75V19.8125Z",
    fill: "#DDB346",
    stroke: "#815719",
    strokeOpacity: 0.5,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 26.1875H11.5V29.4375H14.75V26.1875Z",
    fill: "#DDB346",
    stroke: "#815719",
    strokeOpacity: 0.5,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.3125H26.125",
    stroke: "#4C5B66",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.5625H33.4375",
    stroke: "#4C5B66",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19.8125H26.125",
    stroke: "#4C5B66",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23.0625H33.4375",
    stroke: "#4C5B66",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26.3125H26.125",
    stroke: "#4C5B66",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18 29.5625H33.4375",
    stroke: "#4C5B66",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0625 16.5625H36.6875",
    stroke: "#4C5B66",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0625 23.0625H36.6875",
    stroke: "#4C5B66",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0625 29.5625H36.6875",
    stroke: "#4C5B66",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_103_2965",
    x1: 25,
    y1: 23.5,
    x2: 26,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation);
export default __webpack_public_path__ + "static/media/presentation.91e2184e5028b57de1d584489c40d812.svg";
export { ForwardRef as ReactComponent };